if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', class FaqAccordion extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    onClick(event) {
      const trigger = event.target.closest('.faq-question, .faq-toggle');
      if (!trigger || !this.contains(trigger)) return;

      this.toggleItem(trigger);
    }

    onKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const trigger = event.target.closest('.faq-question, .faq-toggle');
      if (!trigger || !this.contains(trigger)) return;

      event.preventDefault();
      this.toggleItem(trigger);
    }

    toggleItem(trigger) {
      const item = trigger.closest('.faq-accordeon-section-items__item');
      const answer = item?.querySelector('.faq-answer');
      const toggle = item?.querySelector('.faq-toggle');
      const question = item?.querySelector('.faq-question');

      if (!item || !answer || !toggle || !question) return;

      const shouldOpen = !item.classList.contains('is-open');
      item.classList.toggle('is-open', shouldOpen);
      toggle.classList.toggle('open', shouldOpen);
      toggle.setAttribute('aria-expanded', String(shouldOpen));
      question.setAttribute('aria-expanded', String(shouldOpen));
      answer.setAttribute('aria-hidden', String(!shouldOpen));
    }
  });
}
